import { useMemo } from "react";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { useCurrentWorker } from "Reducers/environment/hooks/useCurrentWorker";

export const useSshUrl = () => {
  const currentWorker = useCurrentWorker();
  const environment = useSelectorWithUrlParams(environmentSelector);

  const workerKey = currentWorker?.name || "router";

  const workerSshUrl = useMemo(() => {
    const sshUrls = environment?.getSshUrls() || {};
    return (
      sshUrls[workerKey] ||
      Object.entries(sshUrls)
        .filter(([key]) => key.startsWith(`${workerKey}:`))
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
        .map(([, value], index) => ({
          id: `Host ${index}`,
          value
        }))
    );
  }, [environment, workerKey]);

  return workerSshUrl;
};
